/* eslint-disable @typescript-eslint/no-empty-function */
import classNames from 'classnames'
import Icon from '../babu/Icon'
import RadioButton from '../babu/RadioButton'

export default function SelectPaymentCard(props: { cardClassName?: string }) {
  return (
    <div className={classNames('babu-card pb-xs', props.cardClassName)}>
      <header className="babu-text-button-bold text-text600">付款方式</header>
      <div className="mt-m">
        <RadioButton
          option={{
            groupName: 'payment_method',
            value: 'credit',
            label: 'payment-credit',
            labelNode: (
              <span className="cursor-pointer whitespace-nowrap">
                <Icon name="credit-card" className="mr-xs" />
                信用卡
              </span>
            ),
          }}
          checkedValue="credit"
          onChange={() => {}}
        />
      </div>
      <div className="mt-m">
        <RadioButton
          option={{
            groupName: 'payment_method',
            value: 'atm',
            label: 'payment-atm',
            labelNode: (
              <span className="cursor-pointer whitespace-nowrap">
                <Icon name="money" className="mr-xs" />
                ATM 轉帳（尚未開放）
              </span>
            ),
          }}
          inputProps={{ disabled: true }}
          onChange={() => {}}
        />
      </div>
    </div>
  )
}
